<template lang="pug">
  //- **
  //- * 共通 - ローディング画面を表示したあとにフェードアニメーションを発火するためのコンポーネント
  //- * @components
  //- **

  div
    the-loading
    slot
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import TheLoading from '@/components/TheLoading'
import waypoints from './waypoints'
export default {
  props: {
    fade: {
      class: String
    }
  },
  components: {
    TheLoading,
  },
  data () {
    return {
      current: this.$route.path,
      state: true,
      waypoints: {}
    }
  },
  watch: {
    '$store.state.isLoading' () {
      if (!this.$store.state.isLoading) {
        let target = this.$el.querySelectorAll('._fade')
        this.waypoint(target, 'fade', '70%')
      }
    },
    '$store.state.showEyecatch' () {
      if (this.$store.state.showEyecatch) {
        let target = this.$el.querySelectorAll('._fade_fast')
        this.waypoint(target, 'fade_fast', '85%')
      }
    },
  },
  mounted () {
    let targetFade
    let targetFadeFast
    window.scrollTo({ top: 0 })
    if (this.$route.name !== 'index') {
      targetFade = this.$el.querySelectorAll('._fade')
      targetFadeFast = this.$el.querySelectorAll('._fade_fast')
      this.waypoint(targetFade, 'fade', '70%')
      this.waypoint(targetFadeFast, 'fade_fast', '85%')
    }
  },
  methods: {
    checkClassList (target, className) {
      if (target.classList.contains(className)) return true
    },
    animationObj (target) {
      let animation = []

      animation = [
        {
          className: 'scale',
          speed: .2,
          fade: {
            autoAlpha: 1,
            scale: 1,
          }
        },
        {
          className: [ 'y', 'y2' ],
          speed: .4,
          fade: {
            autoAlpha: 1,
            y: 0,
          }
        },
        {
          className: [ 'x', 'x2' ],
          speed: .4,
          fade: {
            autoAlpha: 1,
            x: 0,
          }
        },
        {
          className: [ 'fade_in_slide-label' ],
          speed: .8,
          fade: {
            autoAlpha: 1,
            delay: 1,
            x: '100%',
          }
        },
        {
          className: [ 'fade_in_slide-inner' ],
          speed: 1,
          fade: {
            autoAlpha: 1,
            delay: 1.8,
          }
        }
      ]

      for (var i = 0; i < animation.length; i++) {
        if (target.className.indexOf(animation[i].className) !== -1) {
          TweenMax.to(target, animation[i].speed, animation[i].fade)
        }
      }
    },
    waypoint: function (target, name, offset) {
      let elem = target
      elem.forEach(x => {
        this.waypoints[name] = new Waypoint({
          element: x,
          handler: () => {
            this.animationObj(x)
          },
          offset: offset,
        })
      })
    },
  },
  beforeDestroy: function () {
    this.$store.commit('IS_LOADING', true)
    this.$store.commit('SHOW_EYECATCH', false)
  }
}
</script>

<style lang="scss">
  .fade_in {
    opacity: 0;
    transition: opacity .8s ease, transform 1.2s ease;

    &.y {
      transform: translateY(100px);
    }

    &.y2 {
      transform: translateY(-30px);
    }

    &.x {
      transform: translateX(100px);
    }
    &.x2 {
      transform: translateX(-100px);
    }

    &.scale {
      transform: scale(1.05);
    }

    &.scale2 {
      transform: scale(.8);
    }

    &.blur {
      filter: blur(30px);
      opacity: 0;
    }
  }


  .fade_in_slide {
    position: relative;
    overflow: hidden;
    display: inline-block;

    &-label {
      @include bg();
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      transform: translateX(-105%);
      z-index: 1;
    }
    &-inner {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TheFade.vue